// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { change } from 'redux-form'
import getModulationSchemeLabelFromLookup from '../getModulationSchemeLabelFromLookup'
import updateModulationsWithMatchingRadioCurveSetId from '../updateModulationsWithMatchingRadioCurveSetId'

import {
  addModulationDetails,
  updateStoredModulationDetails,
} from 'redux/modules/databaseDetails'

// NOTE - we are setting modulation details in databaseDetails redux store
// because we don't submit the modulation information to the API until
// the radio details form is submitted.

const setModulationDetails = modulationDetails => async (dispatch, getState) => {
  const {
    databaseDetails,
    form,
  } = getState()

  // get the name for the Radio Details form
  const sourceForm = databaseDetails.get('sourceForm')
  // and grab the current value for Radio Detail's radio code while you're at it.
  const { radioCode } = form[sourceForm].values

  // ok, so the Modulation Details forms are separate from the Radio Details form
  // in redux-form. As such, there is a disconnect in communication between the two forms' actions.
  // here we trick the Radio Details form into detecting a change to the radioCode input field.
  // But we revert the value back to its previous state immediately after.
  // this makes it so that if the Radio Details form has submit errors and
  // the user has modified a modulation's details after the submit failed,
  // that means they're probably trying to fix the modulation that caused the failure.
  // NOTE - this approach is preferred over using redux-form's clearSubmitErrors
  // because this allows us to persist the submitErrors object for scenarios where
  // the user needs to address multiple modulation errors from a submit.
  dispatch(change(sourceForm, 'radioCode', ''))
  dispatch(change(sourceForm, 'radioCode', radioCode))

  // the modulation details form has a select element for the modulationSchemeId
  // but we want to store the modulation scheme label for presentation.
  modulationDetails.modulationSchemeDescription = (
    dispatch(getModulationSchemeLabelFromLookup(modulationDetails.modulationSchemeId))
  )

  if (modulationDetails.index) {
    await dispatch(updateStoredModulationDetails(modulationDetails))
  } else {
    await dispatch(addModulationDetails(modulationDetails))
  }

  // now update any other modulations which are also using the radioCurvePointId as this modulationDetails.
  // We do this because radioCurve data is a grandchild of radioModulation (which is a child of Radio)
  // and when we look at the different modulation details, we want to make sure that we're looking at the
  // data as if saving the modulation auto saves the radioCurveSet data.
  // then finally once we save the radio, the backend will have a 'last-in' storage approach for the modulations
  // as they define radioCurve data. To ensure it is always correctly stored in the backend, just make
  // all of the the same.
  return dispatch(updateModulationsWithMatchingRadioCurveSetId(modulationDetails))
}

export default setModulationDetails
